import AuthFormSignupVerify from "../../components/Auth/AuthFormSignupVerify";
import TemplateAuthentication from "../../components/UI/TemplateAuthentication";

export default function SignupVerifyPage() {
  return (
    <TemplateAuthentication>
      <AuthFormSignupVerify />
    </TemplateAuthentication>
  );
}
